export default {
  currentMenu: null,
  currentPage: null,
  pages: [],
  name:"flavio",
  builder:{},
  current:{},
  redeSocial:{},
}



// WEBPACK FOOTER //
// ./src/store/state.js